import { render, staticRenderFns } from "./AutoReload.vue?vue&type=template&id=2cb76ca8&scoped=true&"
import script from "./AutoReload.vue?vue&type=script&lang=js&"
export * from "./AutoReload.vue?vue&type=script&lang=js&"
import style0 from "./AutoReload.vue?vue&type=style&index=0&id=2cb76ca8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb76ca8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
installComponents(component, {VBtn})
